import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import submitIcon from '../../../assets/images/SVG/submit_icon.svg';

const SubmitExamModal = ({ isOpen, onClose, onSubmitConfirm, isLoading }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event, reason);
        }
      }}
      disableScrollLock
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(15, 23, 42, 0.4)',
          backdropFilter: 'blur(8px)',
        },
        '& .MuiPaper-root': {
          borderRadius: '24px !important',
          width: '100%',
          maxWidth: '420px',
          margin: '16px',
          boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
          fontFamily: "'Poppins', sans-serif",
          overflow: 'visible',
          position: 'relative',
          p: { xs: 3, sm: 4 },
          pt: { xs: 5, sm: 6 }
        }
      }}
    >
      {/* Top Right Close Button */}
      <IconButton
        onClick={onClose}
        disabled={isLoading}
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 20,
          top: 20,
          color: '#ef4444',
          bgcolor: '#ffffff',
          border: '1.5px solid #fee2e2',
          boxShadow: '0 4px 12px rgba(239, 68, 68, 0.08)',
          transition: 'all 0.25s',
          width: 36,
          height: 36,
          '&:hover': {
            color: '#dc2626',
            backgroundColor: '#fee2e2',
            transform: 'rotate(90deg)'
          }
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </IconButton>

      <DialogContent sx={{ p: 0, textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Centered Submit Icon SVG */}
          <Box
            component="img"
            src={submitIcon}
            alt="Submit Exam"
            sx={{
              width: '90px',
              height: '90px',
              mb: 3,
              filter: 'drop-shadow(0 8px 16px rgba(0, 0, 0, 0.05))'
            }}
          />

          {/* Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 750,
              color: '#1e293b',
              mb: 2,
              fontSize: { xs: '20px', sm: '22px' },
              fontFamily: "'Poppins', sans-serif"
            }}
          >
            Before you submit,
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: '13.5px',
              color: '#64748b',
              fontFamily: "'Poppins', sans-serif",
              lineHeight: 1.5,
              mb: 4,
              px: 2
            }}
          >
            You can go back, review, and change your answers before submitting. Once you submit, you cannot make any changes.
          </Typography>

          {/* Submit Button */}
          <Button
            onClick={onSubmitConfirm}
            variant="contained"
            disabled={isLoading}
            sx={{
              background: 'linear-gradient(90deg, #FF8B4A 0%, #FF6244 100%)',
              color: '#ffffff',
              borderRadius: '9999px',
              width: '100%',
              maxWidth: '280px',
              py: 1.75,
              fontSize: '15.5px',
              fontWeight: 700,
              textTransform: 'none',
              fontFamily: "'Poppins', sans-serif",
              '&:hover': {
                background: 'linear-gradient(90deg, #ff9b5f 0%, #ff7357 100%)',
                transform: 'translateY(-2px)'
              },
              '&:active': {
                transform: 'translateY(0)'
              },
              '&.Mui-disabled': {
                background: '#cbd5e1',
                color: '#94a3b8'
              },
              transition: 'all 0.25s ease'
            }}
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: '#ffffff' }} /> : 'Submit'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SubmitExamModal;
